module.exports = __webpack_public_path__ + "assets/img/Type E (1).18ab851e.jpg";